import React, { useEffect } from 'react';
import { pushRoute } from '../utilities/helpers';
import { fetchClient } from '../store/actions/home-actions';
import { checkServerStatus } from '../store/actions/account-actions';
import { setNotfirstToSelectPage } from '../store/actions/auth-actions';
import Loading from '../components/Loading';

import { useDispatch, useSelector } from 'react-redux'

const LoadingClientData = () => {

  const clientDataLoaded = useSelector(state => state.client.clientDataLoaded);
  const serverStatus = useSelector(state => state.account.serverStatus);
  const token = useSelector(state => state.auth.token);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchClient());
    dispatch(checkServerStatus());
    dispatch(setNotfirstToSelectPage());
    if(serverStatus.status === false){
      pushRoute('/maintain');
    }
    if (clientDataLoaded === true) {

      pushRoute('/')
    }
  }, [token]);

  return (
    <div className="LoadingClientData">
      <Loading />
    </div>
  )
}

export default LoadingClientData;
